<template>
    <form id="formUpdateEcoModuleData" method='post' enctype='multipart/form-data' :action="this.routesubmit">
        <input type="hidden" name="_token" :value="this.csrf">
        <div class="card-body" >
            <div class="row my-auto mx-0">
                <div class="col-md-6">
                    <h5 class="card-title">{{trans.get('common.eco.blocTitle') }}</h5>
                </div>
                <div class="col-md-6">
                    <p>
                        <input type="text" id="cas_usage" name="cas_usage" class="form-control" v-model="datacalculeco.cas_usage" :placeholder="trans.get('common.eco.scenario')">
                    </p>
                </div>
            </div>
            <input id="zonePowers" name="zonePowers" type="hidden" v-model="zonePowersToSave"/>
            <div class="row my-auto mx-0 card p-xl-3">
                <div class = "row my-auto mx-0">
                    <div class ="col-9">
                        <h5 class="card-title"> {{trans.get('common.eco.affinerPuissance')}}</h5>
                    </div>
                    <div class ="col-3">
                        <h5 class="card-title"> {{trans.get('common.eco.productionFirstYear')}}</h5>
                    </div>
                </div>

                <div v-for="(zoneTmp, index) in this.zones" :key="zoneTmp.id" class="row my-auto mx-0 w-100">
                    <div class="col-md-2">
                        <h6>{{zoneTmp.nom}}</h6>
                    </div>
                    <div class="col-md-5">
                        <input type="range" :id="'sliderPower'+zoneTmp.id" name="slider" min="0" :max="zoneTmp.puissance" v-model="zonePowers[index]" v-on:change="updatePower(zoneTmp.id, index)" class="w-75">
                    </div>

                    <div class="col-md-2 text-left">
                        <h6 :id="'val'+zoneTmp.id">{{Math.round(zonePowers[index])}} {{trans.get("common.kwp")}}</h6>
                    </div>

                    <div class="col-md-2">
                        <h6>{{Math.round((zonePowers[index] * zoneTmp.productible)/1000)}} MWh </h6>
                    </div>
                </div>

                <input id="puissTotale" type="hidden" name="puissanceCalc" :value="currentTotalPower"/>
                <input id="prodTotale" type="hidden" name="productionCalc" :value="currentTotalProdFirstYear"/>    

                <div class="row my-auto mx-0">
                    <div class="col-9">
                        <h5 class="card-title">{{trans.get('common.eco.totalpower')}}</h5><h6 id="stringPowerTot">{{Math.round(currentTotalPower)}} {{trans.get("common.kwp")}}</h6>
                    </div>
                    <div class="col-3">
                        <h5 class="card-title">{{trans.get('common.eco.productionTotalFirstYear')}}</h5><h6>{{Math.round(currentTotalProdFirstYear/1000)}} MWh</h6>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row my-auto mx-0 card p-xl-3">
                <h5 class="card-title">{{trans.get('common.eco.affinerExp')}} </h5>
                <div id="divSliderCapex" class="row my-auto mx-0 w-100">
                    <div class="col-md-3">
                        <h6>{{trans.get('common.investment')}}</h6>
                    </div>
                    <div class="col-md-5">
                        <input type="range" id="sliderCapex" name="sliderCapex" min="0" :max="maxCapex" v-model="currentCapexParWc" v-on:change="updateCapex()" class="w-100">
                    </div>
                    <div class="col-md-4 px-0">
                        <div  class="row my-auto mx-0 w-100">
                            <div class="col-md-2 text-right pl-0 pr-2">
                                <h6 id="valCapex">{{currentCapexParWc/1000}}</h6>
                            </div>
                            <div class="col-md-3 text-left px-0">
                                <h6>{{trans.get("common.e_per_wp")}} ,</h6>
                            </div>
                            <div class="col-md-4 text-right">
                                <h6 id="valCapex">{{Math.round(currentCapex)}}</h6>
                            </div>
                            <div class="col-md-3 text-left">
                                <h6>€</h6>
                            </div>
                        </div>
                    </div>
                    <input id="capexCalcBase" type="hidden" name="capexCalcBase" v-model="currentCapex"/>
                </div>
                <div id="divSliderOpex" class="row my-auto mx-0 w-100">
                    <div class="col-md-3">
                        <h6>{{trans.get('common.exploitation_cost')}}</h6>
                    </div>
                    <div class="col-md-5">
                        <input type="range" id="sliderOpex" name="sliderOpex" min="0" :max="maxOpex" v-model="currentOpexParWc" v-on:change="updateOpex()" class="w-100">
                    </div>
                    <div class="col-md-4 px-0">
                        <div  class="row my-auto mx-0 w-100">
                            <div class="col-md-2 text-right pl-0 pr-2">
                                <h6 id="valOpex">{{Math.round(currentOpexParWc,3)}}</h6>
                            </div>
                            <div class="col-md-3 text-left px-0">
                                <h6>{{trans.get("common.e_per_kwp_per_year")}} </h6>
                            </div>
                            <div class="col-md-4 text-right">
                                <h6 id="valCapex">{{Math.round(currentOpex)}}</h6>
                            </div>
                            <div class="col-md-3 text-left">
                                <h6>{{trans.get("common.e_per_year")}}</h6>
                            </div>
                        </div>
                    </div>
                    <input id="opexCalcBase" type="hidden" name="opexCalcBase" v-model="currentOpex"/>
                </div>
            </div>

            <br/>
            

            <div class="row my-auto mx-0">
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.valo1')}} :</h5>
                </div>
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">                            
                    <input name="valo1" id="valo1" class="form-control" type="text" :placeholder="trans.get('common.eco.valo1')" v-model="valo1"/>
                </div>
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.valo2')}} :</h5>
                </div>
                <div class="col-md-23 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <input name="valo2" id="valo2" class="form-control" type="text" :placeholder="trans.get('common.eco.valo2')" v-model="valo2" />
                </div>
            </div>

            <div class="row my-auto mx-0">
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.price1')}} :</h5>
                </div>
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">                            
                    <input name="price1" id="price1" class="form-control" type="number" :placeholder="trans.get('common.eco.price1')" :value="price1" v-on:change="updateInput()"/>
                </div>
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1">
                    <h5 class="colorText">€/MWh</h5>
                </div>
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.price2')}} :</h5>
                </div>
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                    <input name="price2" id="price2" class="form-control" type="number" :placeholder="trans.get('common.eco.price2')" :value="price2" v-on:change="updateInput()"/>
                </div>
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1">
                    <h5 class="colorText">€/MWh</h5>
                </div>
            </div>
            <div class="row my-auto mx-0">
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.productionValueRate1')}} :</h5>
                </div>
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                    <input name="productionValueRate1" id="productionValueRate1" class="form-control" type="number" :placeholder="trans.get('common.eco.productionValueRate1')" :value="rate1" v-on:change="recalcTaux2()"/>
                </div>
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1">
                    <h5 class="colorText">%</h5>
                </div>
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.productionValueRate2')}} :</h5>
                </div>
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                    <input name="productionValueRate2" id="productionValueRate2" class="form-control" type="number" :placeholder="trans.get('common.eco.productionValueRate2')" :value="rate2" v-on:change="updateInput()"/>
                </div>
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1">
                    <h5 class="colorText">%</h5>
                </div>
            </div>
            <div class="row my-auto mx-0">
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.indexation1')}} :</h5>
                </div>
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                    <input name="indexation1" id="indexation1" class="form-control" type="number" :placeholder="trans.get('common.eco.indexation1')" :value="indexation1" v-on:change="updateInput()"/>
                </div>
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1">
                    <h5 class="colorText">%</h5>
                </div>
                <div class="col-md-3 ml-sm-0 col-lg-3 pt-1 px-1 pl-5">
                    <h5 class="colorText">{{trans.get('common.eco.indexation2')}} :</h5>
                </div>
                <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                    <input name="indexation2" id="indexation2" class="form-control" type="number" :placeholder="trans.get('common.eco.indexation2')" :value="indexation2" v-on:change="updateInput()"/>
                </div>
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1">
                    <h5 class="colorText">%</h5>
                </div>
            </div>
            <div class="row my-auto mx-0">
                <div class="col-md-10 d-flex mt-1">
                    <h5 class="colorText text-right w-25 pr-2">Commentaire :</h5>
                    <textarea id="commentEco" class="form-control" :placeholder="comment" name="commenteco"  cols="40" rows="3"></textarea>
                </div>
            </div>
            <div class="row my-auto mx-0">
                <button type="button" class="buttonOriginal" aria-label="Left Align" onclick='document.getElementById("formUpdateEcoModuleData").submit()'  style="margin-left: auto; margin-right: auto " :title="trans.get('common.eco.save')">
                    <div class="row form-inline" style="margin-left: 0px; margin-right: 0px;">
                        <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                    </div> 
                </button>
            </div>
            <div class="row m-auto" style="height : 400px; width : 800px">
                <chartEcoData 
                    :chartData="chartData"
                    :width="chartWidth"
                    :height="chartHeight"
                    ref="chartEcoData">
                </chartEcoData>
            </div>
            <input id="yearNet0" type="hidden" :value="yearNet0"/>
        </div>
    </form>
</template>


<script>
const range = (start, stop, step = 1) => Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
function getValueOrZeroIfNull(val) {
    if(val == null ||val == undefined) {
        return 0;
    }
    return val;
}

import chartEcoData from './charts/chartEcoData.vue';

export default {
    name: 'moduleEco',
    components: {
        chartEcoData
    },
    props: [ 'datacalculeco', 'zones', 'routesubmit', 'productible', 'comment' ],        
    data: function(){
        return {
            valo1: "",
            valo2: "",
            price1: 0,
            rate1: 0,
            pricerate1: 0,
            price2: 0,
            rate2: 0,
            pricerate2: 0,
            indexation1: 0,
            indexation2: 0,
            currentTotalPower: 0,
            currentTotalProdFirstYear:0,
            currentCapex: 0,
            maxCapex: 0,
            currentCapexParWc: 0,
            currentOpex: 0,
            maxOpex: 0,
            currentOpexParWc: 0,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            zonePowers : [],
            zonePowersToSave: [],
            zoneCapex : [],
            zoneOpex : [],
            chartData: {
                labels: Array(20).fill(1).map((x, y) => x + y),
                datasets: [
                    {
                        label: "Gains",
                        backgroundColor: '#79f879',
                        borderColor: '#79f879',
                        data: [],
                    },
                    {
                        label: "Pertes",
                        backgroundColor: '#f87979',
                        borderColor: '#f87979',
                        data: [],
                    },
                    {
                        label: "Net",
                        backgroundColor: '#7979f8',
                        borderColor: '#7979f8',
                        type: "line",
                        data: [],
                        datalabels: {
                            display: function(context) {
                                return context.dataIndex == $("#yearNet0").val() || context.dataIndex == 19 ;
                            },
                            formatter: function(value, context) {
                                return (context.dataIndex+1) +' '+ trans.get('common.year') +' : ' + Math.round(value) + ' €';
                            },
                            align: function(context) {
                                return context.dataIndex == $("#yearNet0").val() ? 60 : -135 ;
                            },
                        },
                    },
                ],
            },
            chartWidth: 800,
            chartHeight: 400,
            yearNet0: 0,
        };
    },
    beforeMount() {
        this.chartData.labels=range(1,21,1);
    },
    mounted: function(){
        if(this.datacalculeco.zonepowers == null || this.datacalculeco.zonepowers == "") {
            this.zones.forEach(e => {
                this.zonePowers.push(e.puissance);
                this.zonePowersToSave.push(e.id+":"+e.puissance);
            });
        } else {
            var previousPowers = this.datacalculeco.zonepowers.split(',');
            previousPowers.forEach(e => {
                let val = e.split(":");
                this.zonePowers.push(val[1]);
                this.zonePowersToSave.push(val[0]+":"+val[1]);
            });
        }
        this.calcTotalPower();
        this.calcTotalProdFirstYear();

        this.valo1=this.datacalculeco.valo1;
        this.valo2=this.datacalculeco.valo2;
        this.price1 = getValueOrZeroIfNull(this.datacalculeco.price1);
        this.price2 = getValueOrZeroIfNull(this.datacalculeco.price2);
        this.rate1 = getValueOrZeroIfNull(this.datacalculeco.rate1);
        this.rate2 = getValueOrZeroIfNull(this.datacalculeco.rate2);
        this.calcValTaux();
        this.indexation1 = getValueOrZeroIfNull(this.datacalculeco.indexation1);
        this.indexation2 = getValueOrZeroIfNull(this.datacalculeco.indexation2);

        this.currentCapex = getValueOrZeroIfNull(this.datacalculeco.capex);
        this.calcCapexParWc();
        this.maxCapex = 2 * this.currentCapexParWc;
        this.currentOpex = getValueOrZeroIfNull(this.datacalculeco.opex);
        this.calcOpexParWc();
        this.maxOpex = 2 * this.currentOpexParWc;

        this.chartData.datasets[0].label = trans.get("common.eco.chart.gains");
        this.chartData.datasets[1].label = trans.get("common.eco.chart.costs");
        this.chartData.datasets[2].label = trans.get("common.eco.chart.net");

        this.updateChartData();

    },
    methods: {
        updatePower(id, index) {
            //this.zonePowers[index] = $("#sliderPower"+id).val();
            this.zonePowersToSave[index] = id+":"+this.zonePowers[index];
            this.calcTotalPower();
            this.calcCapexTotal();
            this.calcOpexTotal();
            this.calcTotalProdFirstYear();
            this.updateChartData();
        },
        calcTotalPower() {
            this.currentTotalPower = this.zonePowers.reduce((p,c) => parseFloat(p)+parseFloat(c));
        },
        calcTotalProdFirstYear(){
            
            this.currentTotalProdFirstYear = 0;
            for (let index = 0; index < this.zones.length; index++) {
                this.currentTotalProdFirstYear += this.zones[index].productible * this.zonePowers[index];
            }
        },
        updateCapex() {
            //this.currentCapexParWc = $("#sliderCapex").val();
            this.calcCapexTotal();
            this.updateChartData();
        },
        updateOpex() {
            //this.currentOpexParWc = $("#sliderOpex").val();
            this.calcOpexTotal();
            this.updateChartData();
        },
        calcCapexParWc() {
            this.currentCapexParWc = this.currentTotalPower == 0 ? 0 : Math.round(this.currentCapex / this.currentTotalPower);
        },
        calcCapexTotal() {
            this.currentCapex = this.currentTotalPower * this.currentCapexParWc;
        },
        calcOpexParWc() {
            this.currentOpexParWc = this.currentTotalPower == 0 ? 0 : Math.round(this.currentOpex / this.currentTotalPower,3);
        },
        calcOpexTotal() {
            this.currentOpex = this.currentTotalPower * this.currentOpexParWc;
        },
        updateInput() {
            this.calcInputs();
            this.updateChartData();
        },
        calcInputs() {
            this.price1 = $("#price1").val();
            this.price2 = $("#price2").val();
            this.rate1 = $("#productionValueRate1").val();
            this.rate2 = $("#productionValueRate2").val();
            this.indexation1 = $("#indexation1").val();
            this.indexation2 = $("#indexation2").val();
            this.calcValTaux();
        },
        calcValTaux() {
            this.pricerate1 = this.price1 * this.rate1 / 100;
            this.pricerate2 = this.price2 * this.rate2 / 100;
        },
        recalcTaux2() {
            $("#productionValueRate2").val(100 - parseFloat($("#productionValueRate1").val()));
            this.updateInput();
        },
        updateChartData() {
            var newChartData = this.chartData;
            newChartData.datasets[0].data = [];
            newChartData.datasets[1].data = [];
            newChartData.datasets[2].data = [];
            var gain, cost, net = 0;
            var production = this.currentTotalProdFirstYear;
            this.yearNet0=0;
            newChartData.labels.forEach(x => {
                let prodIndexee = production * Math.pow(0.996, x-1);
                let indexation1an = Math.pow(1 + this.indexation1/100, x-1);
                let indexation2an = Math.pow(1 + this.indexation2/100, x-1);
                gain = Math.round(prodIndexee * (indexation1an * this.pricerate1 + indexation2an * this.pricerate2) /1000);
                cost = Math.round(this.currentOpex * Math.pow(1.015, x-1));
                // on ajout l'invest aux couts de l'année 1
                if(x == 1)
                    cost += this.currentCapex;
                //let previousNet = newChartData.datasets[2].data.length > 0 ? newChartData.datasets[2].data.at(-1) : 0;
                net = net + gain - cost;
                if (net < 0)
                    this.yearNet0++;
                newChartData.datasets[0].data.push(gain);
                newChartData.datasets[1].data.push(-cost);
                newChartData.datasets[2].data.push(net);
            });
            this.chartData = newChartData;
            this.$refs.chartEcoData.renderBarLineChart();

            var chart = $("canvas#bar-chart").get()[0];
            chart.style.width = this.chartWidth+"px";
            chart.style.height = this.chartHeight+"px";
        },
    },
};
</script>